import { render, staticRenderFns } from "./IdentificacionEvaluacionPagination.vue?vue&type=template&id=1f825482&"
import script from "./IdentificacionEvaluacionPagination.vue?vue&type=script&lang=js&"
export * from "./IdentificacionEvaluacionPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports